import React, { useContext, useEffect } from "react";

import {
  NostoContext,
  type NostoContextProps,
} from "~/providers/NostoProvider";

import { useReviewContext } from "~/hooks/useReviewSnippet";
import { PAGE_SIZE } from "~/hooks/useNosto";

import { ProductCard } from "~/components/ProductCard";
import { SearchListEmpty } from "~/components/Search/List/SearchListEmpty";
import { Pagination } from "./Pagination";

export const Category = () => {
  const { addProductToQueue } = useReviewContext();

  const { products, page, setPage, productCount } =
    useContext<NostoContextProps>(NostoContext);

  useEffect(() => {
    if (!products || !addProductToQueue) return;

    products.forEach((product) => {
      addProductToQueue(product.handle);
    });
  }, [products, addProductToQueue]);

  if (!products) return <SearchListEmpty />;

  return (
    <>
      <div className="grid grid-cols-2 gap-x-pico gap-y-nano md:grid-cols-4">
        {products.map(({ reviewGroup, ...product }, index) => (
          <article
            key={product.handle}
            data-testid="search-result-product-card"
            className="mb-midi"
          >
            <ProductCard {...product} index={index} sizes="33vw" />

            <div
              className="hide-count ruk_rating_snippet ruk_rating_snippet--clp empty:mb-0 mb-pico block px-micro"
              data-sku={reviewGroup}
            />
          </article>
        ))}
      </div>

      {productCount > PAGE_SIZE && (
        <Pagination
          page={page}
          totalProducts={productCount}
          size={PAGE_SIZE}
          onPageChange={setPage}
        />
      )}
    </>
  );
};
